import React from 'react';

const InfoMuroCarbonDeBambu = () => {
  return (
    <section>
      <div className="container">
        <div className="row g-xxl-5 align-items-end mt-n1-9">
          <div className="col-lg-6 order-2 order-lg-1 mt-1-9">
            <div className="pe-lg-1-6 pe-xl-6">
              <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-medidas-2.jpg`} alt="Resistente al agua y moho carbono de bambu" className="mb-6 mb-xl-10" />
              <div className="ps-lg-10 ps-xl-20">
                <div className="d-flex border-bottom pb-1-9 mb-1-9">
                  <div className="flex-shrink-0 me-4">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icons/icon-60.png`} alt="icono" />
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="h5">¿Dónde se puede instalar?</h4>
                    <p className="mb-0">
                    Ideal para la decoración interior de techos y paredes en una amplia variedad de espacios, como: hoteles, villas, restaurantes, galerías, oficinas, espacios comerciales.<br></br>
                    Su versatilidad y diseño elegante lo convierten en una excelente opción para crear ambientes acogedores y sofisticados.
                    </p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-4">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icons/icon-68.png`} alt="icono" />
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="h5">Resistente al agua y al moho</h4>
                    <p className="mb-0">
                    Este producto destaca por su alta resistencia al agua y su capacidad para prevenir el crecimiento de moho y hongos. 
                    Gracias a sus propiedades, se adapta perfectamente a climas húmedos, manteniendo su estado y calidad a lo largo del tiempo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 mt-1-9">
            <div className="ps-lg-1-6 ps-xl-6">
              <div className="title-style1 mb-1-9 mb-lg-10 mb-xl-15">
                <span>Características</span>
                <h2 className="h1 mb-4">Medidas y composición</h2>
                <p className="mb-0">
                Ancho: 1,22m<br></br>
                Longitud: 2.80M<br></br>
                Grosor: 5mm<br></br>
                Material: Compuesto de madera y plástico.<br></br>
                Proceso: Coextrusión + laminación térmica.<br></br>
                </p>
              </div>
              <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-medidas.jpg`} alt="Muro de carbono de bambú" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoMuroCarbonDeBambu;